import React, { useState, useEffect } from "react";
import Breadcrumbs from "../layout/breadcrumb";
import "./employees.css";
import leftArrow from "../../assets/Images/left-arrow.png";
import rightArrow from "../../assets/Images/right-arrow.png";
import { useNavigate } from "react-router-dom";
import { AUTENTICATE_API } from "../../services/apiCalls/authApi";
import Action from "../../assets/Images/action.png";

function Employees() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  useEffect(() => {
    // Fetch employee data from API
    const fetchEmployees = async () => {
      try {
        const response = await AUTENTICATE_API.getEmployees();
        if (response.status === 200 && response.employees) {
          // Sort employees by created_dt in descending order (latest first)
          const sortedEmployees = response.employees.sort(
            (a, b) => new Date(b.created_dt) - new Date(a.created_dt)
          );
          setData(sortedEmployees); // Set the sorted employees to state
        } else {
          console.error("Failed to retrieve employee data");
        }
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };

    fetchEmployees();
  }, []);

  const totalPages = Math.ceil(data.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = data.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handleRowClick = (emp_id) => {
    navigate(`/employee_form?emp_id=${emp_id}`);
  };

  const handleActionClick = (event, emp_id) => {
    event.stopPropagation(); // Prevent the row click handler from triggering
    console.log("Action button clicked with emp_id:", emp_id);
    navigate(`/employee_form?emp_id=${emp_id}&action=view`);
  };

  return (
    <>
      <Breadcrumbs title="Employees" menu="Employees" link="Employees Lists" />
      <div className="d-flex justify-content-end">
        <button
          className="btn btn-primary shadow-sm"
          onClick={() => navigate("/employee_form")}
        >
          Create
        </button>
      </div>
      <div className="table-container">
        <table className="custom-table">
          <thead className="table-header">
            <tr>
              <th>Name</th>
              <th>Designation</th>
              <th>Contact Number</th>
              <th>Email Address</th>
              <th>Role Name</th>
              <th>Created Date</th>
              <th>Updated Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row) => (
              <tr
                key={row.emp_id}
                onClick={() => handleRowClick(row.emp_id)}
                style={{ cursor: "pointer" }}
              >
                <td>{row.employee_name || "N/A"}</td>
                <td>{row.designation_type || "N/A"}</td>
                <td>{row.contact_number || "N/A"}</td>
                <td>{row.email || "N/A"}</td>
                <td>{row.role_name || "N/A"}</td>
                <td>
                  {row.created_dt
                    ? new Date(row.created_dt).toLocaleDateString()
                    : "N/A"}
                </td>
                <td>
                  {row.updated_dt
                    ? new Date(row.updated_dt).toLocaleDateString()
                    : "N/A"}
                </td>
                <td>
                  <div
                    className="action-button"
                    onClick={(event) => handleActionClick(event, row.emp_id)}
                    title="View"
                  >
                    <img src={Action} height="17" width="17" alt="action" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div
          className="pagination"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 15px",
          }}
        >
          <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
            Showing {Math.min((currentPage - 1) * rowsPerPage + 1, data.length)}{" "}
            to {Math.min(currentPage * rowsPerPage, data.length)} of{" "}
            {data.length} entries
          </div>

          <div
            className="pagination-buttons"
            style={{
              fontSize: "14px",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              gap: "5px",
            }}
          >
            <button
              onClick={() => handleClick(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={leftArrow}
                alt="Previous"
                height="10px"
                width="10px"
                style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
              />
            </button>

            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => handleClick(i + 1)}
                style={{
                  background: currentPage === i + 1 ? "#00B69B" : "transparent",
                  color: currentPage === i + 1 ? "#fff" : "#000",
                  border: "none",
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                {i + 1}
              </button>
            ))}

            <button
              onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={rightArrow}
                alt="Next"
                height="10px"
                width="10px"
                style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Employees;
